import React, { useContext, useEffect } from 'react';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { NavbarContext } from './NavbarContext.js';
import NavbarHelpDropdownMenu from './NavbarHelpDropdownMenu.js';
import { getTargetSimple } from './NavbarHelpers.js';

const NavbarHelpLink = ({ url, dataLwtId = 'navbar-help-link', className, linkWrapper, menuItems, menuItemsLinkWrapper, location, target, hideHelpHeader = false, dropdownMenuMaxWidth }) => {
    const { setHelpUrl, setHelpMenuLocation, setHelpItemLinkWrapper, setHelpDropdownItemLinkWrapper, setHelpMenuItems, setHelpTarget, setHideHelpMenuHeader } = useContext(NavbarContext);
    useEffect(() => {
        if (url) {
            setHelpUrl(url);
        }
    }, [url]);
    useEffect(() => {
        if (linkWrapper) {
            setHelpItemLinkWrapper(() => linkWrapper);
        }
    }, [linkWrapper]);
    useEffect(() => {
        if (menuItems) {
            setHelpMenuItems(menuItems);
        }
    }, [menuItems]);
    useEffect(() => {
        if (menuItemsLinkWrapper) {
            setHelpDropdownItemLinkWrapper(() => menuItemsLinkWrapper);
        }
    }, [menuItemsLinkWrapper]);
    useEffect(() => {
        if (location && location.pathname) {
            setHelpMenuLocation(location.pathname);
        }
        if (target) {
            setHelpTarget(target);
        }
    }, [location, target]);
    useEffect(() => {
        setHideHelpMenuHeader(hideHelpHeader);
    }, [hideHelpHeader]);
    if (menuItems) {
        return (React.createElement(NavbarHelpDropdownMenu, { location: location, menuItems: menuItems, dataLwtId: dataLwtId, linkWrapper: menuItemsLinkWrapper, hideHelpHeader: hideHelpHeader, maxWidth: dropdownMenuMaxWidth }));
    }
    return (React.createElement(React.Fragment, null, url && (React.createElement("div", { className: `helix-unified-nav__additional-nav-item helix-unified-nav__additional-help-link ${className ? className : ''}`, "data-lwt-id": dataLwtId },
        React.createElement(React.Fragment, null, linkWrapper ? (React.cloneElement(linkWrapper({
            url,
            props: {
                className: 'helix-unified-nav__nav-button-link'
            },
            label: React.createElement(NavbarHelixIcon, { iconName: 'question_help' })
        }), {
            className: 'helix-unified-nav__nav-button-link',
            'aria-label': 'Help'
        })) : (React.createElement("a", Object.assign({ href: url, className: 'helix-unified-nav__nav-button-link' }, getTargetSimple(target), { "aria-label": 'Help' }),
            React.createElement(NavbarHelixIcon, { iconName: 'question_help' }))))))));
};

export { NavbarHelpLink as default };
//# sourceMappingURL=NavbarHelpLink.js.map
